module.exports = __webpack_public_path__ + "static/media/rank4.188ff1dd.svg";